import React from 'react';
import { Phone, Mail } from 'lucide-react';
import { AGENT } from '@/data/agent';
import { LANDING } from '@/constants/testIds';

/**
 * Sticky mobile-only bottom bar with one-tap Call and Enquire actions.
 * Hidden on md+ screens where the top-bar phone + page CTAs are visible.
 * Padding-bottom is added to <body> via a sibling spacer so content isn't covered.
 */
const StickyMobileCTA = () => {
  const scrollToForm = (e) => {
    e.preventDefault();
    const el = document.getElementById('enquire');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      {/* Spacer so content above doesn't sit under the fixed bar on mobile */}
      <div className="h-16 md:hidden" aria-hidden="true" />

      <div
        data-testid={LANDING.stickyCta}
        className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-bayleys-navy border-t border-white/10 shadow-[0_-8px_24px_rgba(0,0,0,0.18)]"
      >
        <div className="grid grid-cols-2 divide-x divide-white/10">
          <a
            data-testid={LANDING.stickyCallBtn}
            href={AGENT.phoneHref}
            className="flex items-center justify-center gap-2 py-4 text-sm font-medium tracking-wider uppercase text-white active:bg-bayleys-navy-hover transition-colors"
          >
            <Phone className="w-4 h-4" />
            Call Kaid
          </a>
          <a
            data-testid={LANDING.stickyEnquireBtn}
            href="#enquire"
            onClick={scrollToForm}
            className="flex items-center justify-center gap-2 py-4 text-sm font-medium tracking-wider uppercase text-bayleys-navy bg-bayleys-gold active:opacity-90 transition-opacity"
          >
            <Mail className="w-4 h-4" />
            Enquire
          </a>
        </div>
      </div>
    </>
  );
};

export default StickyMobileCTA;
